export const accordeonMenu = () => {

    jQuery(function ($) {
        if($('main').hasClass('page-template-single-lesson')){
            let activeElement = $('.accordion-module__lessons a[href="'+window.location.pathname+'"]');
            if(activeElement.length > 0){
                activeElement.parents('.wp-block-custom-accordion-item').find('.ac-header').click();
                activeElement.addClass('active-menu');
            }
        }
    });
}
